import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
//import all the exports of this file as one variable called _this (we need this at the end)
import * as _this from './lincd-form.js';
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
export var loadData = () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        return import('../data/lincd-form.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/lincd-form.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
export var ns = createNameSpace('http://lincd.org/ont/lincd-form/');
/**
 * The NamedNode of the ontology itself
 */
export var _self = ns('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
//Classes
export var ExampleClass = ns('ExampleClass');
export var Entry = ns('Entry');
export var FieldEntry = ns('FieldEntry');
export var InputField = ns('InputField');
export var Form = ns('Form');
//Properties
export var exampleProperty = ns('exampleProperty');
export var fieldEntry = ns('fieldEntry');
export var inputField = ns('inputField');
export var value = ns('value');
export var slot = ns('slot');
export var targetType = ns('targetType');
export var inputType = ns('inputType');
export var description = ns('description');
//An extra grouping object so all the entities can be accessed from the prefix/name
export const lincdForm = {
    //Classes
    ExampleClass,
    Entry,
    FieldEntry,
    InputField,
    Form,
    //Properties
    exampleProperty,
    fieldEntry,
    inputField,
    value,
    slot,
    targetType,
    inputType,
    description,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
linkedOntology(_this, ns, 'lincd-form', loadData, '../data/lincd-form.json');
//# sourceMappingURL=lincd-form.js.map